import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import TableHeader from "../table/TableHeader";
import TableRow from "../table/TableRow";
import TableTotal from "../../table/TableTotal";
import TableContact from "../table/TableContact";

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 10,
  },
});

const TableBooking = ({ invoice }) => {
  return (
    <View style={styles.tableContainer}>
      <TableContact name={invoice?.items[0]?.enterpriseName} />
      <TableHeader />
      <TableRow items={invoice.items} />
      <TableTotal invoice={invoice} />
    </View>
  );
};

export default TableBooking;
